exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info-head[data-v-5108a9d3]{padding:.24rem .32rem;border-bottom:1px solid #f0f0f0;font-size:.22rem;font-weight:bold}", ""]);

// exports
